// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Gen from "../Control.Monad.Gen/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Lens_Internal_Wander from "../Data.Lens.Internal.Wander/index.js";
import * as Data_Lens_Lens from "../Data.Lens.Lens/index.js";
import * as Data_Lens_Setter from "../Data.Lens.Setter/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_These from "../Data.These/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
import * as URI_AbsoluteURI from "../URI.AbsoluteURI/index.js";
import * as URI_Authority from "../URI.Authority/index.js";
import * as URI_Extra_QueryPairs from "../URI.Extra.QueryPairs/index.js";
import * as URI_HierarchicalPart from "../URI.HierarchicalPart/index.js";
import * as URI_Host from "../URI.Host/index.js";
import * as URI_HostPortPair from "../URI.HostPortPair/index.js";
import * as URI_Path from "../URI.Path/index.js";
import * as URI_Port from "../URI.Port/index.js";
import * as URI_Query from "../URI.Query/index.js";
import * as URI_Scheme from "../URI.Scheme/index.js";
var _hierPart = /* #__PURE__ */ URI_AbsoluteURI["_hierPart"](Data_Profunctor_Strong.strongFn);
var _path = /* #__PURE__ */ URI_HierarchicalPart["_path"](Data_Lens_Internal_Wander.wanderFunction);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString);
var show1 = /* #__PURE__ */ Data_Show.show(Parsing.showParseError);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var apply = /* #__PURE__ */ Control_Apply.apply(Test_QuickCheck_Gen.applyGen);
var elements = /* #__PURE__ */ Control_Monad_Gen.elements(Test_QuickCheck_Gen.monadGenGen)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(URI_Extra_QueryPairs.monoidQueryPairs);
var eq = /* #__PURE__ */ Data_Eq.eq(URI_Extra_QueryPairs.eqKey);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var filter = /* #__PURE__ */ Data_Filterable.filter(Data_Filterable.filterableArray);
var notEq = /* #__PURE__ */ Data_Eq.notEq(URI_Extra_QueryPairs.eqKey);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var _query = /* #__PURE__ */ URI_AbsoluteURI["_query"](Data_Profunctor_Strong.strongFn);
var BasicURL = function (x) {
    return x;
};
var ordBasicURL = /* #__PURE__ */ URI_AbsoluteURI.ordAbsoluteURI(Data_Ord.ordVoid)(/* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_These.ordThese(URI_Host.ordHost)(URI_Port.ordPort)))(URI_Path.ordPath)(Data_Ord.ordVoid)(/* #__PURE__ */ URI_Extra_QueryPairs.ordQueryPairs(URI_Extra_QueryPairs.ordKey)(URI_Extra_QueryPairs.ordValue));
var eqBasicURL = /* #__PURE__ */ URI_AbsoluteURI.eqAbsoluteURI(Data_Eq.eqVoid)(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ Data_These.eqThese(URI_Host.eqHost)(URI_Port.eqPort)))(URI_Path.eqPath)(Data_Eq.eqVoid)(/* #__PURE__ */ URI_Extra_QueryPairs.eqQueryPairs(URI_Extra_QueryPairs.eqKey)(URI_Extra_QueryPairs.eqValue));
var replacePath = function (path) {
    return function (v) {
        return Data_Lens_Setter.set(function ($117) {
            return _hierPart(_path($117));
        })(path)(v);
    };
};
var print = function (v) {
    return URI_AbsoluteURI.print({
        printUserInfo: Data_Void.absurd,
        printHosts: URI_HostPortPair.print(identity)(identity),
        printPath: identity,
        printHierPath: Data_Void.absurd,
        printQuery: URI_Extra_QueryPairs.print(identity)(identity)
    })(v);
};
var printMany = function (urls) {
    return Data_String_Common.joinWith(",")(map(print)(Data_Array_NonEmpty.toArray(urls)));
};
var encodeJsonBasicURL = {
    encodeJson: function (url) {
        return encodeJson(print(url));
    }
};
var showBasicURL = {
    show: function (url) {
        return "BasicURL.fromString " + show(print(url));
    }
};
var parser = /* #__PURE__ */ (function () {
    return Data_Functor.mapFlipped(Parsing.functorParserT)(URI_AbsoluteURI.parser({
        parseUserInfo: Data_Function["const"](new Data_Either.Left("User info is not supported")),
        parseHosts: URI_HostPortPair.parser(pure)(pure),
        parsePath: pure,
        parseHierPath: Data_Function["const"](new Data_Either.Left("Hier paths are not supported")),
        parseQuery: URI_Extra_QueryPairs.parse(pure)(pure)
    }))(BasicURL);
})();
var parse = function (str) {
    return Parsing.runParser(str)(parser);
};
var parseMany = function (str) {
    var parts = Data_String_Common.split(",")(str);
    return bind(traverse(function ($118) {
        return Data_Either.hush(parse($118));
    })(parts))(function (partsParsed) {
        return Data_Array_NonEmpty.fromArray(partsParsed);
    });
};
var decodeJsonBasicURL = {
    decodeJson: function (json) {
        return bind1(decodeJson(json))(function (v) {
            var mapError = function (err) {
                return new Data_Argonaut_Decode_Error.TypeMismatch("Error parsing URL " + (v + (": " + show1(err))));
            };
            var result = parse(v);
            return lmap(mapError)(result);
        });
    }
};
var parseValueBasicURL = {
    parseValue: function ($119) {
        return Data_Either.hush(parse($119));
    }
};
var make = function (scheme) {
    return function (host) {
        return function (port) {
            return function (path) {
                return function (query) {
                    return new URI_AbsoluteURI.AbsoluteURI(scheme, new URI_HierarchicalPart.HierarchicalPartAuth(new URI_Authority.Authority(Data_Maybe.Nothing.value, new Data_Maybe.Just(new Data_These.Both(host, port))), path), query);
                };
            };
        };
    };
};
var arbitraryBasicURL = {
    arbitrary: /* #__PURE__ */ (function () {
        var unsafeMkScheme = function (str) {
            return Data_Maybe["fromMaybe$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("invalid scheme: " + str);
            })(URI_Scheme.fromString(str));
        };
        var unsafeMkQuery = function (str) {
            return Data_Either["fromRight$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("invalid query: " + str);
            })(URI_Extra_QueryPairs.parse(pure)(pure)(URI_Query.fromString(str)));
        };
        var unsafeMkPort = function (str) {
            return Data_Maybe["fromMaybe$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("invalid port: " + show2(str));
            })(URI_Port.fromInt(str));
        };
        var unsafeMkPath = function (str) {
            return Data_Either["fromRight$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("invalid path: " + str);
            })(Parsing.runParser(str)(URI_Path.parser));
        };
        var unsafeMkHost = function (str) {
            return Data_Either["fromRight$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("invalid host: " + str);
            })(Parsing.runParser(str)(URI_Host.parser));
        };
        var schemes = map1(unsafeMkScheme)(Data_Array_NonEmpty["cons$prime"]("http")([ "https", "ftp" ]));
        var queries = map1(unsafeMkQuery)(Data_Array_NonEmpty["cons$prime"]("?")([ "?foo=bar", "?foo=bar&baz=qux" ]));
        var ports = map1(unsafeMkPort)(Data_Array_NonEmpty["cons$prime"](80)([ 443, 8080, 8081, 8082, 8083, 8084, 8085, 8086 ]));
        var paths = map1(unsafeMkPath)(Data_Array_NonEmpty["cons$prime"]("/")([ "/foo", "/foo/bar", "/foo/bar/baz" ]));
        var hosts = map1(unsafeMkHost)(Data_Array_NonEmpty["cons$prime"]("example.com")([ "192.168.0.1", "172.16.254.1", "10.0.0.2" ]));
        return apply(apply(apply(apply(Data_Functor.map(Test_QuickCheck_Gen.functorGen)(function (v) {
            return function (v1) {
                return function (v2) {
                    return function (v3) {
                        return function (v4) {
                            return make(v)(v1)(v2)(v3)(v4);
                        };
                    };
                };
            };
        })(elements(schemes)))(elements(hosts)))(elements(ports)))(elements(paths)))(elements(Data_Array_NonEmpty.cons(Data_Maybe.Nothing.value)(map1(Data_Maybe.Just.create)(queries))));
    })()
};
var getQueryPairs = function (v) {
    return Data_Maybe.fromMaybe(mempty)(v.value2);
};
var getQueryParameter = function (paramName) {
    return function (url) {
        var key = URI_Extra_QueryPairs.keyFromString(paramName);
        var v = getQueryPairs(url);
        var tuple = Data_Array.find(function (v1) {
            return eq(v1.value0)(key);
        })(v);
        return map2(function (v1) {
            return map2(URI_Extra_QueryPairs.valueToString)(v1.value1);
        })(tuple);
    };
};
var fromString = function () {
    return function (str) {
        return Data_Either["fromRight$prime"](function (v) {
            return Partial_Unsafe.unsafeCrashWith("invalid url");
        })(parse(str));
    };
};
var addQueryParameterImpl = function (overwrite) {
    return function (key) {
        return function (value) {
            return function (v) {
                var addQuery = function (initialQuery) {
                    var v1 = Data_Maybe.fromMaybe(mempty)(initialQuery);
                    var encValue = map2(URI_Extra_QueryPairs.valueFromString)(value);
                    var encKey = URI_Extra_QueryPairs.keyFromString(key);
                    var filtered = filter(function ($120) {
                        return (function (v2) {
                            return notEq(v2)(encKey);
                        })(Data_Tuple.fst($120));
                    })(v1);
                    var $112 = overwrite || Data_Array.length(filtered) === Data_Array.length(v1);
                    if ($112) {
                        return append1(filtered)([ new Data_Tuple.Tuple(encKey, encValue) ]);
                    };
                    return v1;
                };
                return Data_Lens_Setter.over(_query)(function ($121) {
                    return Data_Maybe.Just.create(addQuery($121));
                })(v);
            };
        };
    };
};
var addQueryParameterIfNotExists = /* #__PURE__ */ addQueryParameterImpl(false);
var addQueryParameter = /* #__PURE__ */ addQueryParameterImpl(true);
var addPathSegment = function (newSegment) {
    return function (v) {
        var addSegment = function (v1) {
            return Data_Array.snoc(v1)(newSegment);
        };
        return Data_Lens_Setter.over(function ($122) {
            return _hierPart(_path($122));
        })(addSegment)(v);
    };
};
var _scheme = function (dictStrong) {
    var setter = function (v) {
        return function (uri) {
            return uri;
        };
    };
    var getter = function (v) {
        return v;
    };
    var $123 = Data_Lens_Lens.lens(getter)(setter)(dictStrong);
    var $124 = URI_AbsoluteURI["_scheme"](dictStrong);
    return function ($125) {
        return $123($124($125));
    };
};
export {
    _scheme,
    addPathSegment,
    addQueryParameter,
    addQueryParameterIfNotExists,
    fromString,
    getQueryPairs,
    getQueryParameter,
    make,
    parse,
    parseMany,
    print,
    printMany,
    replacePath,
    eqBasicURL,
    ordBasicURL,
    showBasicURL,
    encodeJsonBasicURL,
    decodeJsonBasicURL,
    arbitraryBasicURL,
    parseValueBasicURL
};
//# sourceMappingURL=index.js.map
